<template>
    <div class="activity-indicator-square-orbit">
        <div class="activity-indicator-square-orbit-cube1" />
        <div class="activity-indicator-square-orbit-cube2" />
    </div>
</template>